<template>
    <div class="container">
        <!-- container -->
        <div class="sub_container">
            <div class="flexible">
                <div class="sec">
                    <table class="table_info">
                        <tbody>
                            <tr>
                                <th>소매점명</th>
                                <td>{{customer.Name}}</td>
                            </tr>
                            <tr>
                                <th>소매점코드</th>
                                <td>{{customer.CustomerCode__c}}</td>
                            </tr>
                            <tr>
                                <th>소매점주명</th>
                                <td>{{customer.HostName__c}}</td>
                            </tr>
                            <tr>
                                <th>전화번호</th>
                                <td>{{customer.MainPhoneNo__c}}</td>
                            </tr>
                            <tr v-if="!applyRegion">
                                <th>배송요일</th>
                                <td>{{$root.dayKor(customer.DeliveryDay__c)}}</td>
                            </tr>
                            <tr class="add">
                                <th>주소</th>
                                <td>
                                    {{customer.Address__c}}
                                </td>
                            </tr>
                            <tr>
                                <th>사업자번호</th>
                                <td>{{customer.BusinessRegiNo__c}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="lg_service_num">
                    <dl>
                        <dt>지점 번호</dt>
                        <dd>{{this.$store.state.customer.csTelNo}}</dd>
                    </dl>
                    <div class="button_area">
                        <button type="button" class="btn_call" @click="callCenter">전화걸기</button>
                    </div>
                </div>
            </div>
             <!-- <div class="top_option memberinfo">
                <div class="button_wrap">
                    <div><button type="button" class="btn_blk memberbold" @click="popPolicy()">개인정보 처리방침</button></div>
                </div>
            </div> -->
            <div class="total_button">
                <a class="btn_blk bigger" @click="logout">로그아웃</a>
            </div>

        </div>
        <!-- //container -->

        
    </div>
</template>

<script>
import Customer from '@/api/Customer'
import Code from '@/api/Code'

export default {
    data() {
        return {
            customer: '',
            applyRegion : false,               //월별 주문 횟수 적용 region
            applyRegionCode : [],              //월별 주문 횟수 적용 region 리스트
        }
    },
    created() {
        // 20260615 - 1.적용 region확인
        Code.getCode('C00016', 'T01')
        .then(res => {
          this.applyRegionCode=res.data.refValue1?res.data.refValue1.split(',').map(v => v.trim()).filter(Boolean) : []; //적용 regionCode
        });

        Customer.getDetail()
            .then(res => {
                //await
                this.customer = res.data;

                const currentRegionCode=this.customer.SRZone__r.Level2_RegionCode__c; // 해당 점포의 regionCode;
                this.applyRegion = this.applyRegionCode.includes(currentRegionCode); // region 존재 여부 확인
                console.log("currentRegion: ",currentRegionCode)
            });
    },
    
    methods: {
        callCenter: function() {
            window.location.href = "tel:" + this.$store.state.customer.csTelNo;
        },
        logout() {
            this.$store.commit('logout');
        },
        // popPolicy() {
        //     this.$router.push({name:'Footer',params: { url: 'Member' }})
        // }
    }

};

</script>

<style lang="scss">
  @import '../../assets/styles/css/common.css';
  @import '../../assets/styles/css/default.css';
 

</style>